export enum Language {
	EN = 'en',
}
